export const formatPrice = (price) =>
  Number(`${Math.round(Number(`${price}e2`))}e-2`).toFixed(2);
